import {
  Button,
  HeadingText,
  ParagraphText,
  StackLayout,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { CONTENT_MAX_WIDTH } from '@leagueplatform/web-common-components';

type HealthAssessmentPromptProps = {
  onStartHealthAssessment: () => void;
  onDismiss: () => void;
};

export const HealthAssessmentPrompt = ({
  onStartHealthAssessment,
  onDismiss,
}: HealthAssessmentPromptProps) => {
  const { formatMessage } = useIntl();

  return (
    <StackLayout
      orientation="vertical"
      verticalAlignment="center"
      horizontalAlignment="center"
      css={{
        minHeight: '100vh',
        padding: '$three $two',
        marginX: 'auto',
        maxWidth: CONTENT_MAX_WIDTH,
        textAlign: 'center',
        backgroundColor: '$surfaceBackgroundPrimary',
      }}
    >
      <StackLayout
        orientation="vertical"
        verticalAlignment="center"
        horizontalAlignment="center"
        css={{ width: '100%', maxWidth: '480px', gap: '$two' }}
      >
        <HeadingText level="2" size="lg">
          {formatMessage({ id: 'STR_HEALTH_ASSESSMENT_PROMPT_HEADING' })}
        </HeadingText>
        <ParagraphText>
          {formatMessage({ id: 'STR_HEALTH_ASSESSMENT_PROMPT_BODY' })}
        </ParagraphText>
        <StackLayout
          orientation="vertical"
          verticalAlignment="center"
          horizontalAlignment="stretch"
          css={{ width: '100%', marginTop: '$two', gap: '$one' }}
        >
          <Button onClick={onStartHealthAssessment} width="fillContainer">
            {formatMessage({ id: 'STR_HEALTH_ASSESSMENT_PROMPT_PRIMARY' })}
          </Button>
          <Button priority="tertiary" onClick={onDismiss} width="fillContainer">
            {formatMessage({ id: 'STR_HEALTH_ASSESSMENT_PROMPT_SECONDARY' })}
          </Button>
        </StackLayout>
      </StackLayout>
    </StackLayout>
  );
};
